import { useAppStore } from '@/store/app.ts'
import { useProductListStore } from '@/store/productListStore'
import { getCurrencyUtil } from '@gohighlevel/ghl-proposals-common'
import { unwrapValue } from '@platform-ui/vue-compat-utils'

export const useCurrency = () => {
  const appStore = useAppStore()
  const productListStore = useProductListStore()
  return getCurrencyUtil(
    unwrapValue(appStore.currency) as string,
    productListStore?.currencyDetails?.currency
  )
}
